"use client"

import { memo } from "react"

import { useSetSetting, useSetting } from "@/store/hooks"
import type { UiTheme } from "@/types"

const ORDER: UiTheme[] = ["dark", "light", "system"]
const ICON: Record<UiTheme, string> = {
  dark: "☾",
  light: "☼",
  system: "◐",
}

function ThemeToggleImpl() {
  const theme = useSetting("uiTheme")
  const setSetting = useSetSetting()
  const next = () => {
    const i = ORDER.indexOf(theme)
    setSetting("uiTheme", ORDER[(i + 1) % ORDER.length])
  }
  return (
    <button
      onClick={next}
      aria-label={`Theme: ${theme}. Click to cycle.`}
      title={`Theme: ${theme}`}
      className="text-base hover:opacity-90 px-2 py-1 leading-none"
    >
      {ICON[theme]}
    </button>
  )
}

export const ThemeToggle = memo(ThemeToggleImpl)
